import styles from "./EndQuizModal.module.scss";
import { useNavigate } from "@tanstack/react-router";
import Button from "components/UI/Button/Button";
import useJoyStickNavigation, {
  joystickEvent,
} from "hooks/UseJoyStickNavigation";

type EndQuizModalProps = {
  cancelEndQuiz: boolean;
  setCancelEndQuiz: React.Dispatch<React.SetStateAction<boolean>>;
  setEndQuizModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function EndQuizModal({
  cancelEndQuiz,
  setCancelEndQuiz,
  setEndQuizModal,
}: EndQuizModalProps) {
  const navigate = useNavigate();

  const handleJoyStick = (event: joystickEvent) => {
    console.log(event);
    switch (event) {
      case "left":
        if (!cancelEndQuiz) {
          setCancelEndQuiz(true);
        }
        break;
      case "right":
        if (cancelEndQuiz) {
          setCancelEndQuiz(false);
        }
        break;
      case "enter":
        if (cancelEndQuiz) {
          setEndQuizModal(false);
        } else {
          navigate({ to: "/data-screen-saver" });
        }
        break;
    }
  };

  useJoyStickNavigation(handleJoyStick);

  return (
    <div className={styles.modal}>
      <h1>Vragen stoppen?</h1>
      <div className={styles.modalText}>
        <h2>
          Als je de vragen afbreekt zijn al je gegeven antwoorden weg. Weet je
          zeker dat je de vragen wilt afbreken?
        </h2>
      </div>
      <div className={styles.endQuizModalButtons}>
        <Button
          variant={cancelEndQuiz ? "modalCancelActive" : "modalCancelInActive"}
        >
          Annuleren
        </Button>
        <Button
          variant={cancelEndQuiz ? "modalStopInActive" : "modalStopActive"}
        >
          Stoppen
        </Button>
      </div>
    </div>
  );
}
